"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaNotification = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _utilitaires = require("../utils/utilitaires.js");

require("../css/mfa-notification.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaNotification = /*#__PURE__*/function (_Component) {
  _inherits(MfaNotification, _Component);

  var _super = _createSuper(MfaNotification);

  function MfaNotification(props) {
    var _this;

    _classCallCheck(this, MfaNotification);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fermerFenetre", function (event) {
      if ((0, _utilitaires.estDefini)(_this.props.avertissementFermeture)) {
        _this.props.avertissementFermeture(true);
      }

      _this.setState({
        display: 'none'
      });
    });

    _this.state = {
      display: 'flex'
    };
    return _this;
  }

  _createClass(MfaNotification, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.obtenirNomClasse(),
        style: {
          display: this.state.display
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-wrap flex-grow-1"
      }, (0, _utilitaires.nestPasNulOuVide)(this.props.nomIcone) && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: this.props.nomIcone
      }), (0, _utilitaires.nestPasNulOuVide)(this.props.message) ? this.props.message : this.props.children), this.afficherOptionFermeture() && /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-wrap"
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "x",
        size: "large",
        link: true,
        onClick: this.fermerFenetre
      })));
    }
  }, {
    key: "afficherOptionFermeture",
    value: function afficherOptionFermeture() {
      if ((0, _utilitaires.nestPasNulOuVide)(this.props.afficherOptionFermeture)) {
        return this.props.afficherOptionFermeture;
      }

      return false;
    }
  }, {
    key: "obtenirTaille",
    value: function obtenirTaille() {
      if ((0, _utilitaires.nestPasNulOuVide)(this.props.taille)) {
        if (this.props.taille === 'lg') {
          return ' largeur-lg';
        }

        if (this.props.taille === 'sm' || this.props.taille === 'md') {
          return ' largeur-md';
        }

        if (this.props.taille === 'xxl') {
          return ' largeur-xxl';
        }
      }

      return ' largeur-xl';
    }
  }, {
    key: "couleurNotification",
    value: function couleurNotification(codeNotification) {
      var couleur = " neutre";

      if (codeNotification === 1) {
        couleur = " positive";
      }

      if (codeNotification === 2) {
        couleur = " negative";
      }

      if (codeNotification === 3) {
        couleur = " avis";
      }

      return "".concat(couleur);
    }
  }, {
    key: "obtenirNomClasse",
    value: function obtenirNomClasse() {
      var className = "mfa-notification";
      className += this.obtenirTaille();
      className += this.couleurNotification(this.props.codeNotification);
      return "".concat(className);
    }
  }]);

  return MfaNotification;
}(_react.Component);

exports.MfaNotification = MfaNotification;